export const logoutAsTestatorMixin = {
  methods: {
    logoutAsTestator() {
      const impersonatedTestatorId = this.$store.getters.testatorId;
      this.$store.dispatch('logoutAs');
      this.$router.push({
        name: 'WillSummary',
        params: { id: impersonatedTestatorId },
      });
    },
  },
};
